import type { Component, BaseDataItem } from '@wix/thunderbolt-becky-types'
import type { NodeRefs, ResolvedCursorDataItem, VariantRelationViewItem } from '@wix/thunderbolt-catharsis'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { isRefArray, isValidShape } from './shapeIdsNode'

const getSvgId = (cursor: ResolvedCursorDataItem) => ('svgId' in cursor.media ? cursor.media.svgId : undefined)

export const isVariantRelation = <TItem>(item: BaseDataItem): item is VariantRelationViewItem<TItem> =>
	item.type === 'VariantRelation'

const EMPTY_ARRAY = [] as const

export const cursorShapeIdsNode = createCompNode({
	getDependencies: (component: Component, refs: NodeRefs<{}>) =>
		component.cursorQuery ? refs.cursorQuery(component.cursorQuery) : undefined,
	toViewItem: (__, cursorData) => {
		if (!cursorData) {
			return EMPTY_ARRAY
		}

		if (isRefArray(cursorData)) {
			const shapeIds = cursorData.values
				.map((cursor) => {
					const svgId = isVariantRelation(cursor) ? getSvgId(cursor.to) : getSvgId(cursor)
					return svgId
				})
				.filter(isValidShape)
			return shapeIds
		}

		const svgId = getSvgId(cursorData)
		return isValidShape(svgId) ? [svgId] : EMPTY_ARRAY
	},
})
